import { validarRol } from "../../plugins/acl"

export const defaultUserLogued = () => {
    return {
        name: '',
        email: ''
    }
}
export const defaultCambio = () => {
    return {
        password: "",
        password_confirmation:"",
        url:""

    }
}

// Estado inicial de Google reCAPTCHA.
export const dataInitialReCAPTCHA = () => {
    return {
        isValid: false,
        response: null,
        reload: false
    }
}

// Estado inicial de Microsoft Online.
export const dataInitialMicrosoftOnline = () => {
    return {

        // Para Redirect a MICROSOFT
        loadingPermissions: true,
        loadingNitCompany: true,
        loadingAccessToMicrosoft: true,
        isValidPermissions: true,
        isValidConfigsAzure: true,
        loadingConfigsAzure: true,
        isValidNitCompany: true,
        isValidAccessToMicrosoft: true,

        // Para el redirect a SOLUQUIM
        hasErrorInSessionUser: false,
        loadingAccessToSoluquim: true,
        loadingAccessMicrosoftToApp: true,
        messageError: ""
    }
}

export default {
    user_logued: defaultUserLogued(),
    status: false,
    error: '',
    contrasena: false,
    usuarioTecnico: validarRol('admin-tecnico'),
    usuarioAdmin: validarRol('superadmin') || validarRol('admin'),
    usuarioEmpresa: validarRol('empresa'),
    usuarioEmpresaHSE: validarRol('empresa-hse'),
    usuarioEmpresaContratista: validarRol('empresa-contratista'),
    ingreso: {
        email: "",
        password: ""
    },
    olvido: {
        email: ""
    },
    cambio: defaultCambio(),
    ticket: false,
    columnas: 8,
    // reCAPTCHA información
    loading: false,
    reCAPTCHA: dataInitialReCAPTCHA(),
    microsoftOnline: dataInitialMicrosoftOnline(),
    users_time: [],
    email: localStorage.getItem('email') || '',
    attempts: 0,
    originalRequest: null,
    closeSession: false,
    statusResponse: null,
    my_company: null,
    licence_warning: null,
    basicInfoUser: null
}
